var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelemetrySnapshot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5354 6.96444C15.488 8.91707 15.488 12.0829 13.5354 14.0355M6.4643 14.0355C4.51168 12.0829 4.51168 8.91704 6.4643 6.96442M4.10728 16.3925C0.852912 13.1382 0.852912 7.86179 4.10728 4.60742M15.8924 4.60746C19.1468 7.86183 19.1468 13.1382 15.8924 16.3926M11.6665 10.5C11.6665 11.4205 10.9203 12.1666 9.99984 12.1666C9.07936 12.1666 8.33317 11.4205 8.33317 10.5C8.33317 9.5795 9.07936 8.83331 9.99984 8.83331C10.9203 8.83331 11.6665 9.5795 11.6665 10.5Z",
    stroke: "#344054",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelemetrySnapshot);
export default __webpack_public_path__ + "static/media/telemetrySnapshot.7d60f6c60176335eab36a832b42f85d0.svg";
export { ForwardRef as ReactComponent };